import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

// 三张轮播图（你后面直接换 PNG 路径）
const bannerSlides = [
  {
    id: 1,
    src: './images/carousel-11.jpg',
    title: '专业英语培训 · 从基础到高阶',
    subtitle: '口语 / 雅思 / 商务英语 / 考级辅导'
  },
  {
    id: 2,
    src: './images/carousel-22.jpg',
    title: '雅思高分辅导',
    subtitle: '听读写全面提分，针对性强'
  },
  {
    id: 3,
    src: './images/carousel-33.jpg',
    title: '商务英语课程',
    subtitle: '职场沟通、邮件、谈判技巧'
  }
];

const Home = () => {
  const [current, setCurrent] = useState(0);

  // 自动轮播
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % bannerSlides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-page">

      {/* 头部（不动） */}
      <header className="site-header">
        <div className="logo">
          <h1>励鲲英语</h1>
         </div>
        <div className="header-links">
          <Link to="/login">登录</Link>
          <Link to="/register">注册</Link>
        </div>
      </header>

      {/* ====================== */}
      {/* 🔥 修复完成的轮播图 */}
      {/* ====================== */}
      <div className="carousel">
        {bannerSlides.map((slide, index) => (
          <div
            className={`carousel-item ${index === current ? 'active' : ''}`}
            key={slide.id}
          >
            <img src={slide.src} alt={slide.title} />
            <div className="carousel-text">
              <h2>{slide.title}</h2>
              <p>{slide.subtitle}</p>
            </div>
          </div>
        ))}

        {/* 指示器 */}
        <div className="carousel-dots">
          {bannerSlides.map((_, i) => (
            <span
              key={i}
              className={i === current ? 'dot active' : 'dot'}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>
      </div>

      {/* 导航（不动） */}
      <nav className="site-nav">
        <ul>
          <li><Link to="/">首页</Link></li>
          <li><Link to="/courses">课程介绍</Link></li>
          <li><Link to="/about">关于我们</Link></li>
          <li><Link to="/contact">联系我们</Link></li>
        </ul>
      </nav>

      {/* 内容（不动） */}
      <main className="main-content">
        <section className="intro-section">
          <h2>这里有丰富的托雅学习资料！</h2>
          <p>你可以自由的遨游在托福、雅思的语言环境中！</p>
        </section>

        <div className="course-cards">
          <div className="course-card"><h3>口语提升</h3><p>纯正发音、日常对话</p></div>
          <div className="course-card"><h3>雅思培训</h3><p>听读写全面提分</p></div>
          <div className="course-card"><h3>商务英语</h3><p>职场沟通、邮件</p></div>
        </div>
      </main>

      {/* 底部（不动） */}        
      <footer className="site-footer">
        <div style={{width:'300px',margin:'-20px auto', padding:'20px 0',}}>
		 		<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61011602000359" 
        style={{ display: 'inline-block', textDecoration: 'none', height: '20px', lineHeight: '20px' }}>
                    <img src="./images/police.png" style={{ float: 'left' }}/>
                <p style={{ float: 'left', height: '20px', lineHeight: '20px', margin: '0 0 0 5px', color: '#939393' }}>陕公网安备 61011602000359号</p>
  </a>
</div>
<div style={{width:'300px',margin:'0 auto', padding:'20px 0',}}>
		 		<a target="_blank" href="https://beian.miit.gov.cn/" style={{ display: 'inline-block', textDecoration: 'none', height: '20px', lineHeight: '20px' }}>
		 		  <p style={{ float: 'left', height: '20px', lineHeight: '20px', margin: '0 0 0 5px', color: '#939393' }}>陕ICP备 2020014718号</p>
		 		</a>
</div>
<div style={{width:'300px',margin:'0 auto', padding:'20px 0',}}>
		 		<p style={{ float: 'left', height: '20px', lineHeight: '1px', margin: '-20px 0 0 40px', color: '#939393' }}>联系方式:joanna_t5@qq.com</p>

</div>


      </footer>

    </div>
  );
};

export default Home;